import { render, staticRenderFns } from "./VodStatistics.vue?vue&type=template&id=4270f846&scoped=true"
import script from "./VodStatistics.vue?vue&type=script&lang=js"
export * from "./VodStatistics.vue?vue&type=script&lang=js"
import style0 from "./VodStatistics.vue?vue&type=style&index=0&id=4270f846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4270f846",
  null
  
)

export default component.exports